// temporay way of handling SEL codes
// below are the SEL values that translates to Brazilian SEL levels

// Brazil's Socio-Economic Levels
// export const SEL_CODES = {
// 	1: 'A',
// 	2: 'B1',
// 	3: 'B2',
// 	4: 'C1',
// 	5: 'C2',
// 	6: 'D-E',
// };

// Mexico's Socio-Economic Levels
export const SEL_CODES = {
	1: 'AB',
	2: 'C+',
	3: 'C',
	4: 'C-',
	5: 'D+',
	6: 'D',
	7: 'E',
};


// WEBPACK FOOTER //
// ./src/constants/selCodes.js